// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:  "http://localhost:3050/",
});

export default axiosInstance;

// export const weburl = "https://driver24x7-back.onrender.com/";
export const weburl = "https://driver24x7-back.onrender.com/";
export const testurl = "https://driver24x7-back.onrender.com/";

export const shopurl = "https://driveradmin.spacedeco.in/";
export const mainurl = "https://driver.spacedeco.in/";
export const fronturl = "https://driver.spacedeco.in/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;